import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import Icon from '../../../components/AppIcon';

const TreatmentCaseMetrics = ({ dateRange, provider }) => {
  const procedureData = [
    { category: 'Preventive', volume: 145, complexity: 'Low' },
    { category: 'Restorative', volume: 89, complexity: 'Medium' },
    { category: 'Endodontic', volume: 34, complexity: 'High' },
    { category: 'Periodontal', volume: 56, complexity: 'Medium' },
    { category: 'Prosthodontic', volume: 28, complexity: 'High' },
    { category: 'Oral Surgery', volume: 22, complexity: 'High' }
  ];

  const outcomeMetrics = [
    {
      label: 'Total Procedures',
      value: '374',
      change: '+18%',
      icon: 'Activity',
      color: 'bg-primary/10 text-primary'
    },
    {
      label: 'Success Rate',
      value: '96.8%',
      change: '+1.5%',
      icon: 'CheckCircle2',
      color: 'bg-success/10 text-success'
    },
    {
      label: 'Avg Case Time',
      value: '45 min',
      change: '-5 min',
      icon: 'Clock',
      color: 'bg-warning/10 text-warning'
    },
    {
      label: 'Complex Cases',
      value: '84',
      change: '+12',
      icon: 'AlertCircle',
      color: 'bg-destructive/10 text-destructive'
    }
  ];

  return (
    <div className="bg-card rounded-xl border border-border shadow-elevation-2 p-4 md:p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-lg md:text-xl font-semibold text-foreground flex items-center gap-2">
          <Icon name="Activity" size={20} className="text-primary" />
          Treatment Case Metrics
        </h2>
        <span className="text-xs text-muted-foreground">
          {dateRange === 'day' ? 'Today' : dateRange === 'week' ? 'This Week' : dateRange === 'month' ? 'This Month' : dateRange === 'quarter' ? 'This Quarter' : 'This Year'}
        </span>
      </div>

      <div className="grid grid-cols-2 gap-4 mb-6">
        {outcomeMetrics?.map((metric, index) => (
          <div key={index} className="bg-muted/50 rounded-lg p-3 border border-border">
            <div className="flex items-center justify-between mb-2">
              <div className={`flex items-center justify-center w-8 h-8 rounded-lg ${metric?.color}`}>
                <Icon name={metric?.icon} size={16} />
              </div>
              <span className="text-xs font-semibold text-success">{metric?.change}</span>
            </div>
            <p className="text-xs text-muted-foreground mb-1">{metric?.label}</p>
            <p className="text-xl font-bold text-foreground">{metric?.value}</p>
          </div>
        ))}
      </div>

      <div className="h-64">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={procedureData} margin={{ top: 5, right: 10, left: 0, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
            <XAxis
              dataKey="category"
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '11px' }}
              angle={-15}
              textAnchor="end"
              height={60}
            />
            <YAxis
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '12px' }}
            />
            <Tooltip
              contentStyle={{
                backgroundColor: 'var(--color-card)',
                border: '1px solid var(--color-border)',
                borderRadius: '8px',
                color: 'var(--color-foreground)'
              }}
            />
            <Legend
              wrapperStyle={{
                fontSize: '12px',
                color: 'var(--color-foreground)'
              }}
            />
            <Bar dataKey="volume" fill="#2563EB" radius={[8, 8, 0, 0]} name="Procedure Volume" />
          </BarChart>
        </ResponsiveContainer>
      </div>

      <div className="mt-4 pt-4 border-t border-border">
        <h3 className="text-sm font-semibold text-foreground mb-3">Specialty Performance</h3>
        <div className="space-y-2">
          {procedureData?.slice(0, 3)?.map((procedure, index) => (
            <div key={index} className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 rounded-full bg-primary"></div>
                <span className="text-sm text-foreground">{procedure?.category}</span>
              </div>
              <div className="flex items-center gap-3">
                <span className="text-xs text-muted-foreground">{procedure?.complexity} Complexity</span>
                <span className="text-sm font-semibold text-foreground">{procedure?.volume}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TreatmentCaseMetrics;